import { createApp } from 'vue';
import App from './App.vue';

import '@/assets/styles.scss';

import 'primevue/resources/primevue.min.css';
import 'primevue/resources/themes/bootstrap4-light-blue/theme.css';

import 'primeflex/primeflex.scss';
import 'primeicons/primeicons.css';

import FontAwesomeIcon from '@/assets/font-awesome-icons';

import PrimeVue from 'primevue/config';

import Card from 'primevue/card';

const app = createApp(App);

app.component('Card', Card);
app.component('font-awesome-icon', FontAwesomeIcon);

app.use(PrimeVue);


app.mount('#app');
